import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class OnboardingDashBoardService {

  env = environment;
  constructor(private http: HttpClient) { }

  GetSeamLessLogin() {
    return this.http.post(this.env.webApiUrl + 'api/OnboardingDashBoard/GetUserData', null);
  }
  getOnboardingCreditHistory() {
    return this.http.post(this.env.webApiUrl + 'api/OnboardingDashBoard/CreditHistory', null);
  }
}